import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';

import {
    ProviderTab,
    StyledCard,
    StyledCardContent,
    InputWithEndAdornment,
    SearchIcon,
    ContainedButton,
} from '../../components/index';
import { providerPageWidth } from '../../constant';
import HospitalInfo from '../../components/Provider/Hospital/HospitalInfo';
import ProviderList from '../../components/Provider/Hospital/ProviderList';

const Hospital = ({ history }) => {
    const user = useSelector((state) => state.user);

    const [selectedTab] = useState(0);

    const [searchValue, setSearchValue] = useState('');

    const handleAdd = () => {
        history.push({
            pathname: '/provider/consultant/add',
            state: {
                prevPath: '/provider/consultant',
            },
        });
    };

    return (
        <div
            style={{
                padding: '41px 20px 50px',
                maxWidth: providerPageWidth,
                width: '100%',
            }}
        >
            <Tabs
                value={selectedTab}
                TabIndicatorProps={{ style: { background: 'transparent' } }}
                variant="standard"
            >
                <ProviderTab label="Counseling Service Detail" $active={selectedTab === 0} />
            </Tabs>

            <div
                style={{
                    marginTop: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '20px',
                }}
            >
                <HospitalInfo
                    canEdit={['Admin', 'Provider Admin'].includes(user.staff.staff_role.name)}
                />

                <StyledCard style={{ padding: '30px 50px 24px 35px' }}>
                    <StyledCardContent
                        style={{ display: 'flex', flexDirection: 'column', rowGap: '40px' }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <InputWithEndAdornment
                                id="search"
                                name="search"
                                placeholder="Search name"
                                startAdornment={
                                    <InputAdornment
                                        position="start"
                                        style={{ opacity: 0.6, marginLeft: '10px' }}
                                    >
                                        <SearchIcon fill="gray2" />
                                    </InputAdornment>
                                }
                                type="text"
                                style={{ maxWidth: '325px', height: '32px' }}
                                inputPropsStyle={{ paddingLeft: '15px' }}
                                onChange={(e) => setSearchValue(e.target.value)}
                                value={searchValue}
                                autoComplete="off"
                                inputProps={{ maxLength: 30 }}
                            />
                            <ContainedButton
                                $backgroundColor="purple"
                                $width="230px"
                                $height="32px"
                                onClick={handleAdd}
                            >
                                Add new provider
                            </ContainedButton>
                        </div>
                        <ProviderList searchValue={searchValue} />
                    </StyledCardContent>
                </StyledCard>
            </div>
        </div>
    );
};

Hospital.propTypes = {
    history: PropTypes.object,
};

export default Hospital;
